import type { ComponentProps } from "react"

export default function IndustryK(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M2.66663 23.3318H29.3333V25.9984H2.66663V23.3318ZM13.3333 13.9984H18.6666V21.9984H13.3333V13.9984ZM21.3333 5.99976H26.6666V21.9984H21.3333V5.99976ZM5.33329 11.3318H10.6666V21.9984H5.33329V11.3318Z"
        fill={fill}
      />
    </svg>
  )
}
